import { useState } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import { isToday } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import ru from 'date-fns/locale/ru';
import moment from 'moment';

registerLocale("ru", ru);

const Calendar = ({timeboxes, currentdate, setDate, time, setTime, edittime, enable}) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(null);

    const onChange = (date) => {    
      //console.log(date)    
      setDate(date);
      setTime(null);
    };

    //console.log(currentdate);
    //console.log(timeboxes);

    const filterTime = (date, timeboxes) => {
      const currentDate = new Date(date);

      //const selectDate = currentDate.getFullYear() + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1);

      //var date = new Date();
      const selectDate = moment(currentDate).format('DD.MM.YYYY');

      //console.log(selectDate)
      //console.log(timeboxes)
      let arrayTimeBoxes = timeboxes.filter((timeBox) => timeBox.date === selectDate || (edittime && timeBox.id === edittime.id))

      //console.log(date)
      //console.log(isToday(date))
      if (isToday(date)) {
        return arrayTimeBoxes.filter((timeBox) => {
          const currentdate = new Date();
          let time = timeBox.period.split("-")
          currentdate.setHours(time[0].split(":")[0]);
          currentdate.setMinutes(time[0].split(":")[1]);
          
          return new Date().getTime() < currentdate.getTime();
        });
      } else {
        return arrayTimeBoxes
      }
    };
    
    const CustomTimeInput = ({ date, value, onChange }) => {
      const currentTimeBoxes = timeboxes ? filterTime(date, timeboxes) : [];
  
      //console.log(currentTimeBoxes)
      return (
        <>
          <div className="react-datepicker-time__header">Доступное время</div>
          <div className="react-datepicker-time__buttons">
              {currentTimeBoxes.length > 0
              ? currentTimeBoxes.map((item) => (
                  <button
                      key={item.id}
                      onClick={() => {
                        onChange(item.value);
                        setTime(!time || (time.id !== item.id && time.date !== item.date) ? item : null);
                      }}
                      data-enable={!enable ? true : item.enabled}
                      className={time && item.id === time.id && "selected"}
                  >
                      {item.period}
                  </button>
                  ))
              : "Выберите менеджера и дату"}
          </div>            
        </>
      );
    };

    //console.log(currentdate)

    return (
      <div className="calendar">
        <DatePicker
          inline
          selected={currentdate}
          onChange={onChange}       
          disabledKeyboardNavigation            
          locale="ru"      
          showTimeInput
          customTimeInput={<CustomTimeInput />}
          minDate={new Date()}
          format="dd.MM.yyyy"
          dateFormat="dd.MM.yyyy"
          includeDates={timeboxes && timeboxes.map((timeBox) => timeBox.date.split(".").reverse().join("-"))}
          fixedHeight
        />
      </div> 
    )
}

export default Calendar